<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th>Motivo</th>
      <th class="text-center">Para ganar</th>
      <th class="text-center">Para perder</th>
      <th class="text-center" width="260">Acciones</th>
    </thead>
    <tbody>
      <sin-registros v-show="!motivos" :colspan="4" />
      <tr v-for="motivo in motivos" :key="motivo.id" role="button">
        <td @click="editar(motivo.id)">
          {{ motivo.nombre }}
        </td>
        <td class="text-center" @click="editar(motivo.id)">
          <bool-check :value="motivo.paraGanar" />
        </td>
        <td class="text-center" @click="editar(motivo.id)">
          <bool-check :value="motivo.paraPerder" />
        </td>
        <td nowrap="nowrap" class="td-acciones-auto">
          <b-button-group size="sm">
            <b-button variant="primary" class="actionButton" @click="editar(motivo.id)">
              <v-icon variant="primary" name="edit" width="16" /><span>Editar</span>
            </b-button>
            <boton-eliminar @ok="eliminar(motivo.id)">
              ¿ Desea eliminar el motivo
              <b>{{ motivo.descripcion }}</b> ?
            </boton-eliminar>
          </b-button-group>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    motivos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    editar(id) {
      this.$router.push("/motivosCierreOferta/editar/" + id);
    },
    async eliminar(id) {
      await this.$backend.post("/motivosCierreOferta/eliminar", { id });
      this.$messages.info("Se ha eliminado el registro");
      this.$emit("updated");
    },
  },
};
</script>
